import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AuthContext } from "../../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useSessionHelper } from '../../../../custom/sessionHelper';
import { openSessionModal } from '../../../../store/sessionModalSlice';
import useVisinaTabele from "../../../../custom/visinaTabele";

const Pregled_otpremnice = (props) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user);
  const { sessionHelper } = useSessionHelper();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
  const [selectedRowId, setSelectedRowId] = useState(null);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [izabran, setIzabran] = useState(false);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData, izabran]);

  const getDocumentLocation = (path) => {
    if (!path) return null;
    const normalizedPath = path.replace(/\\/g, '/');
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath);
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const getConfigColumns = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_config: 331
      }),
    };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors);

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

    if (data.length > 0) {
      return { empty: false, data: data };
    } else {
      return { empty: true, data: [] };
    }
  };

  useEffect(() => {
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        user_id: user.userId,
        firma_id: company.companyId
      }),
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/FillInDispacherData", requestOptions)
      .then(handleErrors)
      .then(async (data) => {

        setTableData(data);

        if (data && data.length > 0) {
          const columns = Object.keys(data[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
              label: key,
              value: key
            }));

          setAllColumns(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrder(originalOrder);

          const columnsDB = await getConfigColumns();

          if (!columnsDB.empty && columnsDB.data.length > 0) {
            const arr = JSON.parse(columnsDB.data[0].parametri);
            setSelectedColumns(arr);
          } else {
            setSelectedColumns(columns.slice(0, 5).map(col => col.value));
          }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [auth.token, company.companyId]);


  const handleEditDispacher = (id) => {
    confirmDialog({
      message: "Jel ste sigurni da želite nastaviti sa editovanjem otpremnice?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptEdit(id),
      reject: rejectEdit,
    });
  };

  const acceptEdit = (id) => {
    props.setIdReceiverDispacher({ id: id.Izaberi, source: 'otpremnica' });
    props.setActiveIndex(4);
  };

  const rejectEdit = () => {
    setIzabran(false);
    setSelectedRowId(null);
  };

  const chooseItem = async (rowData) => {
    const id = getId(rowData);

    let resultSession = await sessionHelper(user.userId, 'OTPREMNICA', id);

    if (resultSession.zauzeto) {
      dispatch(openSessionModal({
        type: "SESSION_LOCK",
        message: resultSession.message
      }));
      return;
    }

    setSelectedRowId((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

      if (next) {
        const invoiceID = tableData?.find(t => String(t.Izaberi) === String(rowData.Izaberi));
        if (invoiceID) {
          setIzabran(true);
        }
        handleEditDispacher(invoiceID);
      } else {
        setIzabran(false);
      }

      return next;
    });
  };

  const previewBodyTemplate = (rowData, field) => {
    const filePathsString = rowData[field];
    if (!filePathsString) return '-';

    if (field === 'Izaberi') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Button
            label='Izaberi'
            icon="pi pi-eye"
            className="p-button-text p-button-sm"
            onClick={() => chooseItem(rowData)}
            tooltip="Izaberi otpremnicu za dalji rad"
            tooltipOptions={{ position: 'top' }}
          />
        </div>
      );
    } else {
      const filePaths = filePathsString.split('|').filter(p => p.trim() !== '');
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {filePaths.map((path, idx) => {
            const documentUrl = getDocumentLocation(path);
            if (!documentUrl) return null;
            const fileNameWithExt = path.split('/').pop();
            const fileName = fileNameWithExt.replace(/\.(pdf|jpg|png)$/i, '');
            return (
              <Button
                key={idx}
                label={fileName}
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={() => window.open(documentUrl, '_blank')}
                tooltip="Pregledaj dokument"
                tooltipOptions={{ position: 'top' }}
              />
            );
          })}
        </div>
      );
    }
  };

  const isFileColumn = (field) => {
    return field.startsWith('Prilozi') ||
      field.includes('Izaberi') ||
      field.includes('fajl') ||
      field.includes('upload') ||
      field.endsWith('LK') ||
      field.endsWith('VD') ||
      field.endsWith('PASS') ||
      field.endsWith('VIZA') ||
      field.includes('Dokument');
  };

  const exportExcel = async () => {
    if (!selectedColumns || selectedColumns.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Otpremnice');

    const headers = selectedColumns;
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFEFEFEF' }
      };
      cell.border = {
        top: { style: 'medium' },
        left: { style: 'medium' },
        bottom: { style: 'medium' },
        right: { style: 'medium' }
      };
    });

    tableData.forEach((rowData) => {
      const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    worksheet.columns.forEach((column, i) => {
      const lengths = [
        headers[i].length,
        ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
      ];
      column.width = Math.max(...lengths) + 2;
    });

    const date = new Date();
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Belgrade'
    };
    const serbianDateTime = date.toLocaleString('sr-RS', options)
      .replace(/\s/g, ' ')
      .replace(/,/g, '');

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Otpremnice - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };

  const handleSaveConfig = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptInsertConfig,
      reject: rejectInsertConfig,
    });
  };

  const header = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje">
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
        {allColumns.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <MultiSelect
        value={selectedColumns}
        options={allColumns}
        onChange={(e) => {
        const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
        setSelectedColumns(sorted);
        }}
        optionLabel="label"
        display="chip"
        placeholder={t('nova.odaberiteKolone')}
        style={{ width: '100%' }}
        showSelectAll={true}
        filter
        filterPlaceholder="Pretraži kolone"
        maxSelectedLabels={3}
        selectedItemsLabel="{0} kolona odabrano"
        />
        <button onClick={handleSaveConfig} style={{ marginLeft: '1%' }} className="configSaveButton"><i className="pi pi-save"></i></button>
        </div>
        )}
      </div>
      <input
        type="search"
        onInput={(e) => setGlobalFilter(e.target.value.replace(/s+/g, ' ').trimStart())}
        placeholder={t('nova.phPretraga')}
        className="p-inputtext p-component"
      />
    </div>
  );

  

  const acceptInsertConfig = () => {
    if (selectedColumns.length > 0) {
      let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id_config: 331,
          parametri: selectedColumns
        }),
      };

      fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
        .then(handleErrors)
        .then((data) => {
          if (data.message && data.message === 'Nema izmena u podacima konfiguracije pregleda.') {
            toast.current.show({
              severity: "warn",
              summary: "Upozorenje!",
              detail: data.message,
              life: 3000,
            });
            return;
          }
          toast.current.show({
            severity: "success",
            summary: "Uspešna izmena konfiguracije pregleda otpremnica!",
            life: 3000,
          });
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Morate imati barem 1 izabranu stavku!",
        life: 3000,
      });
    }
  };

  const rejectInsertConfig = () => {
    console.log('Config insert rejected!');
  };

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "0.5em" }}>
        {izabran && <p className="infoPoruka" style={{ margin: '0', display: 'flex', alignItems: 'center' }}>Otpremnica je selektovana. Moguće ažuriranje njenih podataka.</p>}
      </div>

      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData}
        paginator
        rows={redovaTabele}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        header={header}
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={(rowData) => {
          const classes = [];
          if (isSelected(rowData)) {
            classes.push("selected-row");
          }
          return classes.join(" ");
        }}
      >
        {selectedColumns.map((colKey) => {
          const colMeta = allColumns.find(col => col.value === colKey);
          return (
            <Column
              key={colKey}
              field={colKey}
              header={colMeta?.label || colKey}
              sortable
              body={(rowData) => {
                if (isFileColumn(colKey)) {
                  return previewBodyTemplate(rowData, colKey);
                }
                return rowData[colKey] || '-';
              }}
              style={{ minWidth: '150px' }}
            />
          );
        })}
      </DataTable>
      </div>
    </div>
  );
};

export default Pregled_otpremnice;
